module.exports = __webpack_public_path__ + "img/icon-component-label_ShopCoupon.623e155e.svg";